import { useTranslation } from 'react-i18next';

import useEvents from 'lib/hooks/useEvents';
import RearWheelTap from 'lib/Tracking/Srp/SearchFilters/TruckOptionsFilter/RearWheelTap';
import { useTruckOptionsFilter } from 'lib/hooks/useSrpFilters';

import LabeledCheckBox from 'components/Shared/SearchFilter/CheckBox/LabeledCheckBox';
import SearchFilterSubHeader from 'components/Shared/SearchFilter/SearchFilterSubHeader';
import { useContext } from 'react';
import SrpEventContext from 'contexts/SrpEventContext';

const rearWheelTypes: ['single', 'dual'] = ['single', 'dual'];

export default function RearWheelFilter(): JSX.Element {
  const logger = useEvents();
  const { sourcePage } = useContext(SrpEventContext);
  const { t } = useTranslation();
  const { value, setValue } = useTruckOptionsFilter();

  function onTap(label: string, isSelected: boolean): void {
    setValue({ ...value, rearWheel: { ...value?.rearWheel, [label]: isSelected } });
    logger.log(RearWheelTap(label, sourcePage));
  }

  return (
    <>
      <SearchFilterSubHeader subTitle={t(`srp.filters.truckOptions.rearWheel`)} />
      {rearWheelTypes.map((rearWheelType) => {
        const rearWheelTypeLabel = t(`srp.filters.truckOptions.${rearWheelType}`);
        return (
          <LabeledCheckBox
            key={rearWheelType}
            label={rearWheelTypeLabel}
            aria-label={`${rearWheelTypeLabel}-label`}
            isChecked={value.rearWheel[rearWheelType]}
            onClick={(isSelected: boolean): void => onTap(rearWheelType, isSelected)}
          />
        );
      })}
    </>
  );
}
